import { useOutletContext } from "react-router-dom";

import ImportsView from "../views/ImportsView/ImportsView";

export default function Imports() {
	const context = useOutletContext();

	return <ImportsView {...context} />;
}
